// extracted by mini-css-extract-plugin
export default {"button":"_2Z5Up","expand":"AwqQi","suffixIcon":"_357YO","colorFromFullButton":"bZaAK","colorFromHollowButton":"_1z2Ib"};